const BOUND_NORTH = window.MAP_BOUND_NORTH
const BOUND_EAST = window.MAP_BOUND_EAST
const BOUND_SOUTH = window.MAP_BOUND_SOUTH
const BOUND_WEST = window.MAP_BOUND_WEST
const CENTER_LAT = window.MAP_CENTER_LAT
const CENTER_LNG = window.MAP_CENTER_LNG
const ZOOM = window.MAP_ZOOM

export {
    BOUND_NORTH,
    BOUND_EAST,
    BOUND_SOUTH,
    BOUND_WEST,
    CENTER_LAT,
    CENTER_LNG,
    ZOOM,
}
